/**
 * @since 2018/10/29
 * @author fanjingjian
 */

export const AUDITOR_TYPE_LIST = {
  System: '系统',
  Operator: '运营人员',
  Sales: '销售人员',
};

export const AUDIT_TASK_TYPE_LIST = {
  APPROVAL_REJECT: 'APPROVAL_REJECT', // 审批任务
  QUOTE: 'QUOTE', // 举证
  ARBITRATION: 'ARBITRATION', // 仲裁
  SHOWITEM: 'SHOWITEM', // 仅仅展示
  ABANDON_QUOTE_SHOWITEM: 'ABANDON_QUOTE_SHOWITEM', //展示【已放弃举证】
  TIMEOUT_QUOTE_SHOWITEM: 'TIMEOUT_QUOTE_SHOWITEM', //展示【举证超时】
  QUOTE_APPROVAL: 'QUOTE_APPROVAL', //展示【拒绝并举证】【同意】【查看详情】
};

export const AUDIT_TASK_TYPE_SHOWDETAIL_LIST = {
  6: '已同意', // 原'已放弃举证',
  8: '举证超时',
  9: '已拒绝并举证', // 原'已举证'
};

export const PUBLISH_BEFORE_AUDIT_LIST = {
  6: '已放弃举证',
  8: '举证超时',
  9: '已举证',
};

export const NOTICE_LIST = {
  14: '已通知商家', // 原'已放弃举证',
  16: '超时未处理',
  15: '已通知商家', // 原'已举证'
};

// 筛选条件
export const FILTER_TYPE = {
  ALL: 'ALL', // 所有
  WAITING: 'WAITING', // 待审核,
  TIMEOUT: 'TIMEOUT', // 超时
  HANDLED: 'HANDLED', // 已处理
  ACCEPTED: 'ACCEPTED', // 通过
  DENIED: 'DENIED', // 驳回
  PARTIAL_ACCEPTED: 'PARTIAL_ACCEPTED', // 部分通过
  CANCELED: 'CANCELED',
};

export const NEWSHOPS_FIELD_STATUS_SHOW_POIID = ['WAITING', 'DENIED']; // 我的新增中待审核、被驳回时展示 POI ID

export const REPORT_TYPE_LIST = {
  BASIC: 'BASIC', // 基本信息报错
  PARENT: 'PARENT', // 父子关系报错
  UPDATE: 'UPDATE', // 其它报错
  RELATION: 'RELATION', // 重复门店相关报错
  CATE: 'CATE', // 类目报错
  SERVICE: 'SERVICE', // 上门服务报错
  GROUP: 'GROUP', // 连锁报错
  RELATION_SOURCE: 'RELATION_SOURCE', // 外源关联关系报错
};

export const NEWSHOPS_TASK_TYPE = {
  NEW: 'NEW', // 新增
};

// 不允许申诉的 field.stdName 值
export const REPORT_CANT_APPROVAL_FIELD_STDNAME = [
  'alias',
  'branchName',
  'useType',
  'businessHours',
];

// 我的报错 -- 不允许申诉的 field.stdName 值(目前只有我的报错)
export const REPORT_CANT_APPROVAL_FIELD_STDNAME_MYREPORT = [
  'alias',
  // 'branchName',
  'useType',
];

// 我的报错--不允许申诉的 field.stdName 值 提示文案
export const REPORT_CANT_APPROVAL_FIELD_STDNAME_SHOWTEXT = {
  alias: '别名',
  branchName: '分店名',
  useType: '门店类型',
  businessHours: '营业时间',
};

export const AUDIT_TYPE_LIST = {
  NEW: '', // 待办，新流程
  ELSE: 'old', // 其它待办, 对应老流程
  CATE: '', // 其它待办, 对应老流程
};

// 不允许申诉的类型列表
export const REPORT_CANT_APPROVAL_TYPE_FIELD_LIST = [
  'PATERNITY', // 父子关系
];
// 其他报错不允许申诉的类型列表
export const REPORT_CANT_APPROVAL_TYPE_IN_UPDATE = ['APPEAL'];
// 重复门店相关报错不允许申诉的类型列表
export const REPORT_CANT_APPROVAL_TYPE_IN_RELATION = [
  'TypeReportDuplicateAppeal', // 举报重复申诉
  'TypeReportSplitAppeal', // 举报拆分申诉
  'TypeMergeMainAppeal', // 变更主门店申诉
];
export const NEWSHOPS_CANT_APPROVAL = ['APPEAL_WAIT_AUDIT'];
export const GROUPS_CANT_APPROVAL = ['APPEAL_WAIT_AUDIT'];
// 重复门店相关报错的报错状态
export const REPORT_FIELD_STATUS = {
  STATUS_INITIAL: '初始状态',
  STATUS_NOCONFIRM: '不确定',
  STATUS_ACCEPT: '采纳',
  STATUS_REFUSE: '拒绝',
  STATUS_MODIFIED: '修改后采纳',
  STATUS_LOCKED: '非本流程修改',
};
export const REPORT_FIELD_STATUS_ACCEPT = 'STATUS_ACCEPT';
// 我的新增审核状态
export const NEWSHOPS_FIELD_STATUS = {
  success: '已通过',
  wait: '待审核',
  refuse: '被驳回',
  auditsuccess: '申诉后通过',
};
// 连锁记录审核状态
export const GROUPS_FIELD_STATUS = {
  success: '已通过',
  wait: '待审核',
  refuse: '被驳回',
  accept: '已通过',
};

// 连锁 报错类型
export const GROUPS_ERROR_REPORT_TYPE = {
  FEED_TYPE_STATUS: '营业状态报错',
  FEED_TYPE_MAP: '地图报错',
  FEED_TYPE_DUP: '商户重复报错',
  FEED_TYPE_CHAIN: '连锁报错',
  Feed_TYPE_APPEFL: '申诉报错',
  Feed_TYPE_OPEN: '垃圾、侵权、虚假商户报开',
  FEED_TYPE_ADD_CHAIN: '新增连锁报错',
  FEED_TYPE_DEL_CHAIN: '解除连锁报错',
  APPEAL_ADD_CHAIN: '新增连锁申诉',
  APPEAL_DEL_CHAIN: '解除连锁申诉',
  FEED_TYPE_OTHER: '其他报错',
};

export const PC_INFO_REPORT_APPEAL_CLIENTTYPE = 220;

//类目报错审核节点状态
export const CATE_PROCRESULT = {
  0: '通过',
  1: '拒绝',
  2: '待审核',
};

// mytodo 私海BD确认 bdconfirm，重复流程BD类型 枚举 3、4，枚举8和3，4逻辑保持一致
export const BD_CONFIRM_SUBSOURCE = [3, 4, 8, 12];
// 不可信（虚假）流程下线 枚举=5
export const UNTRUST_SUBSOURCE = [5];
// 重复流程BD类型 枚举 3、4
// 不可信（虚假）流程下线 枚举=5、7
export const CONFIRM_SUBSOURCE = [3, 4, 5, 7, 8];
// 不可信（虚假）流程下线 枚举=5 上传和输入的提示文案
export const UNTRUST_TIPS = {
  inputTips: '请详细填写拒绝原因并附上有效门店电话以便审核人员回拨确认',
  uploadTips: '请提供带有地址牌的清晰门头图和营业执照举证',
};
export const BD_CONFIRM_UPLOAD_TIPS =
  '请提供带有地址牌的清晰门头图和营业执照举证。建议提交更多辅助信息，如另外一家重复门店带有地址牌或周边环境信息的清晰门头图';
export const BD_CONFIRM_COLUMNS = [
  {
    title: '门店ID',
    dataIndex: 'dpShopId',
    key: 'dpShopId',
    render: (text, record, index) => {
      return (
        <div>
          <div>
            点评ID：
            {text}
          </div>
          <div>
            美团ID：
            {record.mtShopId}
          </div>
        </div>
      );
    },
  },
  {
    title: '名称',
    dataIndex: 'shopName',
    key: 'shopName',
  },
  {
    title: '地址',
    dataIndex: 'address',
    key: 'address',
  },
];

export const APPEAL_STATUS = {
  CAN_APPEAL: 1, // 1-可申诉
  DISABLE_APPEAL: 3, // 3-超时不可申诉
  APPEALED: 8, // 8-已申诉
  APPEAL_AUDITING: 4, // 4-申诉处理中
};

/*
  新流程appealStatus
  NONE(0, "无需申诉"), // 无需申诉，默认状态
  ENABLED(1, "可申诉"), // 可申诉状态
  DISABLED(2, "不可申诉"), // 不可申诉, 如商户名包含敏感词导致不可申诉
  TIMEOUT(3, "超时不可申诉"), // 超时不可申诉
  PROCESING(4, "已申诉"), // 已申诉,申诉处理中
*/
export const NEW_SHOWAPPEAL_STATUS = [1, 3, 4]; // 新流程需要展示申诉文案的状态
export const NEW_DISABLED_APPEALMAP = {
  3: '超时不可申诉',
  4: '已申诉',
};

/*
* 需求文档：https://km.sankuai.com/page/223429137
*/
// 审核结果状态
export const AUDIT_RESULT_TEXT = {
  ERROR: '异常',
  SUCCESS: '通过',
  REFUSE: '驳回',
  MODIFY: '修改后通过',
  PART_ADOPT: '部分通过',
  CANCEL: '撤销',
  WAIT: '审核中',
  UNKNOWN: '未知',
};

// 审核流程中状态
export const AUDIT_STEP_RESULT_TEXT = {
  ...AUDIT_RESULT_TEXT,
  NOCONFIRM: '不确定，转人审',
  SKIP: '跳过',
  TIMEOUT: '超时未审核',
  PROOF: '已举证',
  GIVE_UP_PROOF: '放弃举证',
};

// 审核类型
export const AUDIT_TYPE = {
  creditAudit: '诚信审核',
  ai: '系统审核',
  auditbusi: '业务审核',
  categoryAudit: '类目仲裁审核',
  audit: '人工审核',
  rearCreditAudit: '诚信审核',
};

// 上门服务报错/基本信息 各状态对应的status
export const API_REQUEST_STATUS = {
  [FILTER_TYPE.ALL]: '', // 所有
  [FILTER_TYPE.WAITING]: 0, // 待审核,
  [FILTER_TYPE.DENIED]: 3, // 驳回
  [FILTER_TYPE.CANCELED]: 2, //
  [FILTER_TYPE.ACCEPTED]: 1, // 通过
};

// 报错类型
export const REPORT_TYPE = {
  BASIC: 1, // 基础字段报错
  RELATION: 2, // 重复门店报错流程
  CATEGORY: 3, // 类目报错
  CHAIN: 4, // 连锁报错流程
  SERVICE: 5, // 上门服务报错
  PARENT: 7, // 父子关系报错
  GROUP: 3, // 连锁报错
  RELATION_SOURCE: 8, // 外源关联关系报错
};

// tab列表
export const TAB_LIST = [
  {
    key: 'my-report',
    tab: '我的报错',
    tabList: [
      {
        key: REPORT_TYPE_LIST.BASIC,
        tab: '基本信息报错',
        filterList: [
          {
            label: '全部',
            value: FILTER_TYPE.ALL,
          },
          {
            label: '待审核',
            value: FILTER_TYPE.WAITING,
          },
          {
            label: '被驳回',
            value: FILTER_TYPE.DENIED,
          },
          {
            label: '已通过',
            value: FILTER_TYPE.ACCEPTED,
          },
        ],
      },
      {
        key: REPORT_TYPE_LIST.PARENT,
        tab: '父子关系报错',
        filterList: [
          {
            label: '全部',
            value: FILTER_TYPE.ALL,
          },
          {
            label: '待审核',
            value: FILTER_TYPE.WAITING,
          },
          {
            label: '被驳回',
            value: FILTER_TYPE.DENIED,
          },
          {
            label: '已通过',
            value: FILTER_TYPE.ACCEPTED,
          },
        ],
      },
      {
        key: REPORT_TYPE_LIST.RELATION,
        tab: '重复门店相关报错',
        filterList: [
          {
            label: '全部',
            value: FILTER_TYPE.ALL,
          },
          {
            label: '待审核',
            value: FILTER_TYPE.WAITING,
          },
          {
            label: '被驳回',
            value: FILTER_TYPE.DENIED,
          },
          {
            label: '已通过',
            value: FILTER_TYPE.ACCEPTED,
          },
        ],
      },
      {
        key: REPORT_TYPE_LIST.SERVICE,
        tab: '上门服务报错',
        filterList: [
          {
            label: '全部',
            value: FILTER_TYPE.ALL,
          },
          {
            label: '待审核',
            value: FILTER_TYPE.WAITING,
          },
          {
            label: '被驳回',
            value: FILTER_TYPE.DENIED,
          },
          {
            label: '已通过',
            value: FILTER_TYPE.ACCEPTED,
          },
        ],
      },
      {
        key: REPORT_TYPE_LIST.GROUP,
        tab: '连锁报错',
        filterList: [
          {
            label: '全部',
            value: FILTER_TYPE.ALL,
          },
          {
            label: '待审核',
            value: FILTER_TYPE.WAITING,
          },
          {
            label: '被驳回',
            value: FILTER_TYPE.DENIED,
          },
          {
            label: '已通过',
            value: FILTER_TYPE.ACCEPTED,
          },
        ],
      },
      {
        key: REPORT_TYPE_LIST.RELATION_SOURCE,
        tab: '门店匹配关系报错',
        filterList: [
          {
            label: '全部',
            value: FILTER_TYPE.ALL,
          },
          {
            label: '待审核',
            value: FILTER_TYPE.WAITING,
          },
          {
            label: '被驳回',
            value: FILTER_TYPE.DENIED,
          },
          {
            label: '已通过',
            value: FILTER_TYPE.ACCEPTED,
          },
        ],
      },
    ],
  },
  {
    key: 'my-todo',
    tab: '我的待办',
    filterList: [
      {
        label: '待审核',
        value: FILTER_TYPE.WAITING,
      },
      {
        label: '已处理',
        value: FILTER_TYPE.HANDLED,
      },
      {
        label: '已超时',
        value: FILTER_TYPE.TIMEOUT,
      },
    ],
  },
  {
    key: 'my-newshops',
    tab: '我的新增',
    filterList: [
      {
        label: '待审核',
        value: FILTER_TYPE.WAITING,
      },
      {
        label: '被驳回',
        value: FILTER_TYPE.DENIED,
      },
      {
        label: '已通过',
        value: FILTER_TYPE.ACCEPTED,
      },
    ],
  },
];

export const AUDIT_STATUS = {
  WAITING: 0, // 审核中
  ACCEPTED: 1, // 已通过
  NOT_PASS: 3, // 未通过
  APPEAL_WAITING: 4, // 申诉审核中
  APPEAL_ACCEPTED: 5, // 申诉已通过
  APPEAL_NOT_PASS: 6, // 申诉未通过
};

export const ACTION_ENUM = {
  alreadyActionBtn: 0,
  alreadyActionDetailText: 1,
  detail: 2,
  notice: 3,
  quote: 4,
  giveUpQuote: 5,
  onlineDeliveryQuote: 6, // 非线上配送
  onlineDeliveryGiveUpQuote: 7, // 是线上配送
  onlineDeliveryQuoteDone: 8, // 非线上配送
  onlineDeliveryGiveUpQuoteDone: 9, // 是线上配送
  timeout: 10, // 固定展示超时文案
  goConfirm: 21, // 去确认
};

export const CLEARANCE_REASON = ['搬迁', '转让', '永久不营业', '其他'];
